
(function () {
    // When an icon is clicked, it will show the corresponding info and hide the other infos.
    function HandleIcons(elements) {
        elements.forEach(element => {
            const icons = element.querySelectorAll(".icon")
            icons.forEach(icon => {
                icon.addEventListener("click", () => {
                    const show = !icon.classList.contains("show")
                    icons.forEach(iconItem => {
                        iconItem.classList.remove("show")
                    })
                    if (show) {
                        icon.classList.add("show")
                    }
                })
            })
        })
    }

    const trailinfos = document.querySelectorAll(".trailinfo")
    const ips = document.querySelectorAll(".ips")
    const placeicons = document.querySelectorAll(".placeicons")

    HandleIcons(trailinfos)
    HandleIcons(ips)
    HandleIcons(placeicons)

})();
